(() => {
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
        const lockAccessdeniedMessages = document.querySelectorAll(".bss-lock-price-access-deniend-6055");
        lockAccessdeniedMessages.forEach(message => {
            const newLinkElement = document.createElement("a");
            newLinkElement.href = "https://eminence.com/pages/place-wholesale-order";
            newLinkElement.setAttribute("checked", true);
            newLinkElement.innerText = message.innerText;
            newLinkElement.classList.add('bss-custom-access-denied-message-6055')
            message.parentElement.appendChild(newLinkElement);
            message.remove();
        });
    };
    const observer = new MutationObserver(callback);
    observer.observe(document.body, config);

    
})()